module.exports = __webpack_public_path__ + "img/icon-12.42b72b75.png";